/**
 * 절기별 추천떡 — Service text 스크롤 스파이
 * - sticky 사이드 네비: 카드 제목에 맞춰 검정 활성화
 * - 네비 클릭 시 해당 첫 카드로 스크롤
 */
export function initSeasonScrollSpy(root: ParentNode): () => void {
  const section = root.querySelector<HTMLElement>('[data-season-section]');
  if (!section) return () => undefined;

  const navItems = Array.from(
    section.querySelectorAll<HTMLElement>('[data-season-nav]'),
  );
  const cards = Array.from(
    section.querySelectorAll<HTMLElement>('[data-season-card]'),
  );

  if (navItems.length === 0 || cards.length === 0) return () => undefined;

  const setActive = (key: string) => {
    navItems.forEach((item) => {
      const active = item.dataset.seasonNav === key;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  const pickActiveKey = () => {
    const marker = window.innerHeight * 0.35;
    let bestKey = cards[0]?.dataset.seasonCard ?? '';
    let bestDist = Number.POSITIVE_INFINITY;

    cards.forEach((card) => {
      const key = card.dataset.seasonCard;
      if (!key) return;
      const rect = card.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const mid = rect.top + rect.height * 0.35;
      const dist = Math.abs(mid - marker);
      if (dist < bestDist) {
        bestDist = dist;
        bestKey = key;
      }
    });

    return bestKey;
  };

  const onScroll = () => {
    const key = pickActiveKey();
    if (key) setActive(key);
  };

  const onNavClick = (event: Event) => {
    const target = (event.target as Element | null)?.closest<HTMLElement>(
      '[data-season-nav]',
    );
    if (!target || !section.contains(target)) return;

    const key = target.dataset.seasonNav;
    if (!key) return;

    event.preventDefault();
    const card = section.querySelector<HTMLElement>(
      `[data-season-card="${key}"]`,
    );
    if (!card) return;

    setActive(key);
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  setActive(pickActiveKey() || (navItems[0]?.dataset.seasonNav ?? ''));

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  section.addEventListener('click', onNavClick);

  return () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    section.removeEventListener('click', onNavClick);
  };
}
